import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	backlogIssueMoveCancel,
	backlogIssueMoveConfirm,
} from '../../../../state/actions/board/backlog-issue-move/index.tsx';
import { isDialogVisibleSelector } from '../../../../state/selectors/board/backlog-issue-move-selectors.tsx';
import type { State } from '../../../../state/types.tsx';
import BacklogIssueMoveDialog from './view.tsx';

export default connect(
	(state: State) => ({
		isOpen: isDialogVisibleSelector(state),
	}),
	{
		onCancel: backlogIssueMoveCancel,
		onConfirm: backlogIssueMoveConfirm,
	},
)(BacklogIssueMoveDialog);
